module.exports = function(target){
	return target instanceof RegExp;
}